import React from 'react';
import { RecommendationBar } from '../../../components/Shared';
import { MagazineNewspaperCitingSection } from '../../../components/citing/MagazineNewspaperCiting';
import { MagazineNewspaperContributorFunctions, MAGAZINE_PUBLICATION_INFO, NEWSPAPER_PUBLICATION_INFO, ONLINE_DATABASE_PUB_INFO, TabHeaders, TestIds } from '../constants';
import { ContributorSection } from '../../../components/ContributorSection';
import GenericSection from '../../../components/GenericSection';
import { MAGAZINE_PUB_SECTION_FIELDS, NEWSPAPER_PUB_SECTION_FIELDS } from '../constants/fieldList/common';
import { ONLINE_DATABASE_SECTION_FIELDS } from '../constants/fieldList/onlineDatabase';
import { MoreOptionsSection } from '../../../components/MoreOptions';
import { SourceType } from '../../../types';

// Component to render OnlineDatabase tab in Magazine-Newspaper form
var OnlineDatabaseForm = function OnlineDatabaseForm(_ref) {
  var onSourceChange = _ref.onSourceChange,
    source = _ref.source;
  var pubInfoFields = source === SourceType.MAGAZINE ? MAGAZINE_PUB_SECTION_FIELDS : NEWSPAPER_PUB_SECTION_FIELDS;
  var sectionTitle = source === SourceType.MAGAZINE ? MAGAZINE_PUBLICATION_INFO : NEWSPAPER_PUBLICATION_INFO;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecommendationBar, null), /*#__PURE__*/React.createElement(MagazineNewspaperCitingSection, {
    selectedTab: TabHeaders.OnlineDatabase,
    onSourceChange: onSourceChange,
    source: source
  }), /*#__PURE__*/React.createElement(ContributorSection, {
    functionOptions: MagazineNewspaperContributorFunctions
  }), /*#__PURE__*/React.createElement(GenericSection, {
    fieldList: pubInfoFields,
    sectionTitle: sectionTitle,
    name: "pub".concat(source),
    "data-test": TestIds.MAGAZINE_PUB_INFO_SECTION,
    selectedTab: TabHeaders.OnlineDatabase
  }), /*#__PURE__*/React.createElement(GenericSection, {
    fieldList: ONLINE_DATABASE_SECTION_FIELDS,
    sectionTitle: ONLINE_DATABASE_PUB_INFO,
    name: "pubdatabase",
    "data-test": TestIds.MAGAZINE_ONLINE_DB_PUB_INFO_SECTION,
    selectedTab: TabHeaders.OnlineDatabase
  }), /*#__PURE__*/React.createElement(MoreOptionsSection, null));
};
export default OnlineDatabaseForm;